/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TrainingCourseTypeMapping } from '../../models/training-course-type-mapping';

export interface ApiMasterTrainingGetTrainingCourseTypeMappingGet$Params {
}

export function apiMasterTrainingGetTrainingCourseTypeMappingGet(http: HttpClient, rootUrl: string, params?: ApiMasterTrainingGetTrainingCourseTypeMappingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrainingCourseTypeMapping>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTrainingGetTrainingCourseTypeMappingGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TrainingCourseTypeMapping>>;
    })
  );
}

apiMasterTrainingGetTrainingCourseTypeMappingGet.PATH = '/api/Master/Training/GetTrainingCourseTypeMapping';
